<div
  class="absolute inset-0 z-30 flex justify-end bg-neutral-800 opacity-30"
  (click)="closeModal()"></div>
<div
  [ngClass]="isWebview ? 'pt-14' : 'pt-5'"
  class="absolute left-0 top-0 z-40 flex h-screen max-h-screen w-full flex-col bg-white px-6 pb-[120px] md:left-1/2 md:w-1/2 md:rounded-s-3xl md:p-10 md:pb-10">
  <div *ngIf="!showDetails(); else showDetail">
    <app-unexpected-error
      class="fixed inset-x-0 bottom-24 z-50 mx-auto max-w-[500px] px-4 md:bottom-10"
      *ngIf="unexpectedError$ | async" />
    <button
      class="hidden self-start md:block"
      app-icon-button
      name="x"
      (click)="close.emit()"></button>
    <button
      class="block self-start md:hidden"
      app-icon-button
      name="arrow-narrow-left"
      (click)="close.emit()"></button>
    <div class="flex items-center pt-6">
      <span class="prose prose-display-lg self-stretch font-semibold" translate>
        menu.notifications
      </span>
      <app-badge color="red" class="ms-4" *ngIf="!!unReadMsgCount()">{{
        unReadMsgCount()
      }}</app-badge>
    </div>

    <div *ngIf="notifications().length === 0" class="my-5" translate>msg.no_notify</div>
    <div class="h-[80vh] w-full overflow-y-auto pl-3 md:h-[77vh]">
      <div
        *ngFor="let notification of notifications(); let last$ = last"
        class="cursor-pointer border-b border-neutral-100 py-5 md:py-6"
        [ngClass]="{ 'border-b-0': last$ }">
        <div (click)="showDetailNoti(notification.id)">
          <ng-container *ngIf="notification.announcement">
            <div class="flex items-start justify-between">
              <div class="relative flex w-[70%] items-center gap-3">
                <p
                  class="absolute left-[-10px] top-1 h-3 min-h-[12px] w-3 min-w-[12px] rounded-[50%] bg-neutral-200 p-0.5"
                  [ngClass]="{ 'bg-primary-600': notification.is_read === 0 }"></p>

                <span
                  class="max-one-line self-stretch px-3 text-sm font-semibold md:text-base"
                  [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }">
                  {{ notification.announcement!.subject }}
                </span>
              </div>
              <span
                class="text-right text-[10px] lowercase text-neutral-700 md:text-xs"
                [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }"
                >{{ notification.created_at | date: "hh:mm aa, dd/MM/Y" }}
              </span>
            </div>
            <div class="flex pt-2 md:pt-4">
              <span
                class="max-3-line self-stretch pl-3 text-xs font-regular text-neutral-700 md:text-sm"
                [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }">
                {{ notification.announcement!.subtitle }}
              </span>
            </div>
          </ng-container>
          <ng-container *ngIf="notification.notification_template">
            <div class="flex items-start justify-between">
              <div class="relative flex w-[70%] items-center gap-3">
                <p
                  class="absolute left-[-10px] top-1 h-3 min-h-[12px] w-3 min-w-[12px] rounded-[50%] bg-neutral-200 p-0.5"
                  [ngClass]="{ 'bg-primary-600': notification.is_read === 0 }"></p>

                <span
                  class="max-one-line self-stretch px-3 text-sm font-semibold md:text-base"
                  [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }">
                  {{ notification.notification_template_subject_snapshot }}
                </span>
              </div>
              <span
                class="mr-3 text-right text-[10px] lowercase text-neutral-700 md:text-xs"
                [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }"
                >{{ notification.created_at | date: "hh:mm aa, dd/MM/Y" }}
              </span>
            </div>
            <div class="flex pt-2 md:pt-4">
              <span
                class="max-3-line self-stretch pl-3 text-xs font-regular text-neutral-700 md:text-sm"
                [ngClass]="{ 'text-neutral-500': notification.is_read > 0 }">
                {{ notification.notification_template_subtitle_snapshot }}
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #showDetail>
  <div *ngIf="notification()">
    <app-unexpected-error
      class="fixed inset-x-0 bottom-24 z-50 mx-auto max-w-[500px] px-4 md:bottom-10"
      *ngIf="unexpectedError$ | async" />
    <button
      app-icon-button
      name="arrow-narrow-left"
      class="mb-10 self-start"
      (click)="closeDetailModal()"></button>
    <ng-container *ngIf="notification()?.announcement">
      <p class="prose prose-display-lg mb-3 font-semibold">
        {{ notification()?.announcement?.subject }}
      </p>
      <span class="mb-6 text-left text-[10px] text-neutral-700">{{
        notification()?.created_at | date: "dd/MM/Y"
      }}</span>
      <p
        *ngIf="(notification()?.announcement)!.app_content"
        class="my-6 mb-6 text-sm text-neutral-700"
        [innerHTML]="(notification()?.announcement!.app_content) | safeHtml"></p>
      <div
        *ngIf="notification()?.announcement?.attachment"
        class="my-5 flex w-full items-center justify-between rounded-lg border border-neutral-200 p-2">
        <div class="flex items-center">
          <div class="mr-4 flex items-center justify-center rounded-full bg-neutral-100 p-2">
            <app-icon name="file-attachment"></app-icon>
          </div>
          <div>
            <p class="mb-1 text-sm">{{ getFileName(notification()?.announcement?.attachment) }}</p>
            <p class="text-xs uppercase text-neutral-500">
              {{ getFileType(notification()?.announcement?.attachment) }}
            </p>
          </div>
        </div>
        <button
          app-icon-button
          name="download"
          size="sm"
          (click)="download(notification()!.announcement!.attachment)"></button>
      </div>
    </ng-container>
    <ng-container *ngIf="notification()?.notification_template">
      <p class="prose prose-display-lg mb-3 font-semibold">
        {{ notification()?.notification_template_subject_snapshot }}
      </p>
      <span class="mb-6 text-left text-[10px] text-neutral-700">{{
        notification()?.created_at | date: "dd/MM/Y"
      }}</span>
      <p
        *ngIf="(notification()?.notification_template)!.template_content"
        class="my-6 mb-6 text-sm text-neutral-700"
        [innerHTML]="notification()?.notification_template_content_snapshot | safeHtml">
      </p>
    </ng-container>
    <button class="w-full" app-button (click)="closeDetailModal()" translate>btn.ok_got_it</button>
  </div>
</ng-template>
